"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mergeCollapsedMargins;
function mergeCollapsedMargins(collapsedMarginTop, nativeStyle) {
  if (typeof collapsedMarginTop !== 'number') {
    return nativeStyle;
  }
  return _objectSpread(_objectSpread({}, nativeStyle), {}, {
    marginTop: collapsedMarginTop
  });
}